import { getShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import { OrderConfirmationPageContext } from "@insite/content-library/Pages/OrderConfirmationPage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import React, { FC, useEffect, useState } from "react";
import { connect } from "react-redux";


const enum fields {
    enableGoogleMSReview = "enableGoogleMSReview",
    googleMerchantId = "googleMerchantId",
    googleScriptSrc = "googleScriptSrc",
    daysForStockedDelivery = "daysForStockedDelivery"
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.enableGoogleMSReview]: boolean;
        [fields.googleMerchantId]: string;
        [fields.googleScriptSrc]: string;
        [fields.daysForStockedDelivery]: number;

    };
}

const mapStateToProps = (state: ApplicationState) => ({
    cartState: getCartState(state, state.pages.orderConfirmation.cartId),
    shipTo: getShipToState(state, getCartState(state, state.pages.orderConfirmation.cartId).value?.shipToId).value,

});

const mapDispatchToProps = {
};

type Props = HasHistory &
    WidgetProps &
    ReturnType<typeof mapStateToProps> & {

};

const OrderConfirmationGoogleMSReview: FC<Props> = props => {
    const { cartState, shipTo } = props;

    if (!props.fields.enableGoogleMSReview || !cartState.value) {
        return null;
    }

    const [isLoaded, setIsLoaded] = useState(false);
    const [isPageLoaded, setIsPageLoaded] = useState(false);
    useEffect(() => {
        if (props.fields.enableGoogleMSReview && isLoaded === false) {
            loadScript();
        }
        setIsPageLoaded(true);
    }, []);


    const loadScript = () => {
        if (isLoaded === false) {
            const s = document.createElement("script");
            s.src = props.fields.googleScriptSrc;
            s.async = true;
            s.defer = true;
            s.onload = () => setIsLoaded(true);
            document.getElementsByTagName("body")[0].appendChild(s);
        }
    };


    useEffect(() => {
        if (isLoaded) {

            var cartObj = props?.cartState?.value;
            var cartLineObj = props?.cartState?.value?.cartLines;
            var avgLeadTimeDay = 0;
            var stockAvailable = 0;
            var email = cartObj?.initiatedByUserName;
            if (cartLineObj) {
                var upcCodeJsonArray = [];
                for (var i = 0; i < cartLineObj.length; i++) {
                    var avgLeadTime = Number(cartLineObj[i].properties.averageLeadTime);
                    if (avgLeadTime > avgLeadTimeDay) {
                        avgLeadTimeDay = avgLeadTime;
                        stockAvailable = cartLineObj[i].qtyOnHand;
                    }

                    var upcObj = {
                        gtin: cartLineObj[i].properties.orderLineUpcCode
                    };
                    upcCodeJsonArray.push(upcObj);

                }
            }

            var upcCodeStr = JSON.stringify(upcCodeJsonArray);


            var estimatedDeliveryDate = "";
            var today = new Date();
            if (stockAvailable >= 1) {
                today.setDate(today.getDate() + props.fields.daysForStockedDelivery);
            }
            else {
                today.setDate(today.getDate() + avgLeadTimeDay);
            }
            let formatedMonth = today.getMonth() + 1;
            if (formatedMonth < 10) {
                formatedMonth = 0 + formatedMonth;
            }
            estimatedDeliveryDate = (today.getFullYear() + "-" + (String(today.getMonth() + 1).padStart(2, '0')) + "-" + (String(today.getDate())).padStart(2, '0')).toString();

            if (cartObj?.isGuestOrder) {
                email = shipTo?.email || cartObj?.initiatedByUserName;
            }

            let orderId = cartObj?.orderNumber || cartObj?.orderNumber;

            let scriptCall = null;
            let scriptLang = null;



            scriptCall = document.createElement("script");
            scriptCall.innerHTML = "";
            scriptCall.innerHTML = `window.renderOptIn = function () {
                window.gapi.load('surveyoptin', function () {
                    window.gapi.surveyoptin.render({
                        "merchant_id": "${props.fields.googleMerchantId}",                 
                        "order_id": "${orderId}",                 
                        "email": "${email}",                 
                        "delivery_country": "${shipTo?.country?.abbreviation}", 
                        "estimated_delivery_date": "${estimatedDeliveryDate}",
                        "products": ${upcCodeStr}                    
                    });
                    });                    
                    }`;


            scriptLang = document.createElement("script");
            scriptLang.innerHTML = "";
            scriptLang.innerHTML =
                `
                window.___gcfg = {

                lang: 'en-US'
                
                };                 
            `;

            document.body.appendChild(scriptCall);
            document.body.appendChild(scriptLang);
        }
    }, [isLoaded, isPageLoaded]);

    return (
        <></>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(OrderConfirmationGoogleMSReview)),
    definition: {
        displayName: "Google Merchant Seller Reviews",
        allowedContexts: [OrderConfirmationPageContext],
        group: "Order Confirmation",
        fieldDefinitions: [
            {
                name: fields.enableGoogleMSReview,
                displayName: "Enable Google Merchant Seller Review?",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Translatable",
            },
            {
                name: fields.googleMerchantId,
                displayName: "Google Merchant Id",
                editorTemplate: "TextField",
                defaultValue: "240546774",
                fieldType: "Translatable",
                isVisible: widget => widget.fields.enableGoogleMSReview,
            },
            {
                name: fields.googleScriptSrc,
                displayName: "Google Script Src",
                editorTemplate: "TextField",
                defaultValue: "https://apis.google.com/js/platform.js?onload=renderOptIn",
                fieldType: "Translatable",
                isVisible: widget => widget.fields.enableGoogleMSReview,
            },
            {
                name: fields.daysForStockedDelivery,
                displayName: "Stocked Items Delivery Days",
                editorTemplate: "IntegerField",
                defaultValue: 5,
                fieldType: "General",
                isVisible: widget => widget.fields.enableGoogleMSReview,
            },
        ]
    },

};

export default widgetModule;
